module.exports = __webpack_public_path__ + "assets/img/29_225_big.e424b54d.jpg";